export const chatTabs = [
  {
    id: "support",
    label: "Admin Support",
  },
  {
    id: "orders",
    label: "Orders",
  },
];
